<section id="Categoria-juegos" class="custom-section pb-10">
  <div class="Contenedor">
    <!-- Título de la categoría -->
    <h2 class="text-2xl font-semibold text_white">Mis Últimas Apuestas</h2>
    <p class="pb-6 text-base font-normal text_gray">Consulta tus últimas apuestas realizadas</p>

    <div class="card_color pt-3 px-6 pb-2 rounded-md">
      <div class="rounded-md">
        <!-- Card Title -->

        <!-- Tabla responsive -->
        <div class="flex flex-col">
          <div class="overflow-x-auto">
            <div class="inline-block min-w-full align-middle">
              <div class="overflow-hidden">
                <table class="min-w-full divide_y_customize divide_color_customize">
                  <thead>
                    <tr>
                      <!-- Columna de "Juego" -->
                      <!-- Columna de "Juego" -->
                      <th scope="col" class="p-4 text-sm font-medium tracking-wider text-left text-white uppercase">
                        <div class="flex items-center space-x-2">
                          <dd class="text-sm font-semibold text-white flex items-center gap-2">
                            <span class="text-xl gap-2">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="text_color_customize w-5 h-5">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path
                                  d="M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2z" />
                                <path d="M8 6h.01" />
                                <path d="M16 18h.01" />
                                <path d="M12 16l-3 -4l3 -4l3 4z" />
                              </svg>
                            </span>
                            <span class="hidden sm:inline">Juego</span>
                          </dd>
                        </div>
                      </th>
                      <!-- Columna de "Usuario" (oculta en pantallas menores a 600px) -->

                      <!-- Columna de "Apuesta" -->
                      <th scope="col" class="p-4 text-sm font-medium tracking-wider text-left text_white uppercase">
                        <div class="flex items-center space-x-2">
                          <dd class="text-sm font-semibold text_white flex items-center gap-2">
                            <span class="text-xl gap-2">
                              <!-- Icono SVG de Apuesta -->
                              <svg width="24" height="24" viewBox="0 0 26 26" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="text_color_customize w-5 h-5">
                                <g clip-path="url(#clip0_1821_7911)">
                                  <path
                                    d="M23.243 11.945V7.01503C23.243 6.40084 22.9898 5.8118 22.5392 5.37751C22.0887 4.94321 21.4775 4.69922 20.8403 4.69922H4.02179C3.38457 4.69922 2.77344 4.94321 2.32286 5.37751C1.87228 5.8118 1.61914 6.40084 1.61914 7.01503V16.2783C1.61914 16.8925 1.87228 17.4815 2.32286 17.9158C2.77344 18.3501 3.38457 18.5941 4.02179 18.5941H16.507M18.9525 11.7565H18.9633M5.95247 11.7565H5.96331M14.3761 8.50649H11.6677C11.2368 8.50649 10.8234 8.67769 10.5187 8.98244C10.2139 9.28719 10.0427 9.70051 10.0427 10.1315C10.0427 10.5625 10.2139 10.9758 10.5187 11.2805C10.8234 11.5853 11.2368 11.7565 11.6677 11.7565H12.7511C13.1821 11.7565 13.5954 11.9277 13.9001 12.2324C14.2049 12.5372 14.3761 12.9505 14.3761 13.3815C14.3761 13.8125 14.2049 14.2258 13.9001 14.5305C13.5954 14.8353 13.1821 15.0065 12.7511 15.0065H10.0427M12.2094 15.0065V16.0898M12.2094 7.42316V8.50649"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                  <path d="M24.8984 15.0033L19.4818 20.4199" stroke="currentColor" stroke-width="2"
                                    stroke-linecap="round" stroke-linejoin="round" />
                                  <path d="M19.4824 15.5449L19.4824 20.4199L24.3574 20.4199" stroke="currentColor"
                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1821_7911">
                                    <rect width="26" height="26" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <span class="hidden sm:inline">Apuesta</span>
                          </dd>
                        </div>
                      </th>

                      <!-- Columna de "Ganancia" -->
                      <th scope="col" class="p-4 text-sm font-medium tracking-wider text-left text_white uppercase">
                        <div class="flex items-center space-x-2">
                          <dd class="text-sm font-semibold text_white flex items-center gap-2">
                            <span class="text-xl gap-2">
                              <!-- Icono SVG de Ganancia -->
                              <svg width="24" height="24" viewBox="0 0 26 26" fill="none"
                                xmlns="http://www.w3.org/2000/svg" class="text_color_customize w-5 h-5">
                                <g clip-path="url(#clip0_1821_7916)">
                                  <path
                                    d="M18.9633 21.3024L24.38 15.8858M24.38 15.8858V20.7608M24.38 15.8858H19.505M23.243 11.945V7.01503C23.243 6.40084 22.9898 5.8118 22.5392 5.37751C22.0887 4.94321 21.4775 4.69922 20.8403 4.69922H4.02179C3.38457 4.69922 2.77344 4.94321 2.32286 5.37751C1.87228 5.8118 1.61914 6.40084 1.61914 7.01503V16.2783C1.61914 16.8925 1.87228 17.4815 2.32286 17.9158C2.77344 18.3501 3.38457 18.5941 4.02179 18.5941H16.507M18.9525 11.7565H18.9633M5.95247 11.7565H5.96331M14.3761 8.50649H11.6677C11.2368 8.50649 10.8234 8.67769 10.5187 8.98244C10.214 9.28719 10.0427 9.70051 10.0427 10.1315C10.0427 10.5625 10.214 10.9758 10.5187 11.2805C10.8234 11.5853 11.2368 11.7565 11.6677 11.7565H12.7511C13.1821 11.7565 13.5954 11.9277 13.9001 12.2324C14.2049 12.5372 14.3761 12.9505 14.3761 13.3815C14.3761 13.8125 14.2049 14.2258 13.9001 14.5305C13.5954 14.8353 13.1821 15.0065 12.7511 15.0065H10.0427M12.2094 15.0065V16.0898M12.2094 7.42316V8.50649"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1821_7916">
                                    <rect width="26" height="26" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </span>
                            <span class="hidden sm:inline">Ganancia</span>
                          </dd>
                        </div>
                      </th>

                      <!-- Columna de "Hora" -->
                      <th scope="col" class="p-4 text-sm font-medium tracking-wider text-left text_white uppercase">
                        <div class="flex items-center space-x-2">
                          <dd class="text-sm font-semibold text_white flex items-center gap-2">
                            <span class="text-xl gap-2">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round"
                                class="text_color_customize text-xl icon icon-tabler icons-tabler-outline icon-tabler-clock-hour-4">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                <path d="M12 12l3 2" />
                                <path d="M12 7v5" />
                              </svg>
                            </span>
                            <span class="hidden sm:inline">Fecha y
                              Hora</span>
                            <!-- Solo muestra el texto en pantallas grandes -->
                          </dd>
                        </div>
                      </th>
                    </tr>
                  </thead>

                  <tbody class="divide_y_customize divide_color_customize">
                    <ng-container *ngIf="items.length === 0; else elseTemplate">
                      <tr>
                        <td class="opacity-50 py-10 text-md font-normal whitespace-nowrap flex-1 text-white" colspan="4"
                          style="text-align: center; min-height: 100px;">
                          <div class="flex flex-col items-center justify-center w-full">
                            <i class="ti ti-alert-circle no-items text-gray-100 text-4xl"></i>
                            <span class="mt-2 text-gray-100 fontcustom">Sin información por mostrar</span>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                    <ng-template #elseTemplate>
                      <tr *ngFor="let item of items">
                        <td class="p-2 lg:p-4 text-sm lg:text-lg font-normal text_gray whitespace-nowrap">
                          <button class="block">
                            <!-- Enlace tradicional -->
                            <div class="flex items-center text-white">
                              <div class="w-10 h-10 md:w-12 md:h-12">
                                <!-- Contenedor cuadrado responsive -->
                                <img
                                  class="w-full h-full rounded-lg border_color_customize border-2 object-cover cursor-pointer"
                                  (click)="openGame(item.game)"
                                  [src]="item.game.iconUrl ? item.game.iconUrl: 'assets/images/no-photo-available.png'"
                                  alt="Crash 3DX" />
                              </div>
                              <span class="hidden md:inline ml-2">{{item.game.name}}</span>
                            </div>
                          </button>
                        </td>

                        <!-- Datos de "Apuesta" -->
                        <td class="p-4 text-md font-normal text_white whitespace-nowrap">
                          <div class="flex items-center space-x-2">
                            <dd class="text-sm font-semibold text_gray flex items-center gap-2">
                              <span class="text_yellow text-xl gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="icon icon-tabler icons-tabler-outline icon-tabler-poker-chip">
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                  <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
                                  <path d="M12 3v4" />
                                  <path d="M12 17v4" />
                                  <path d="M3 12h4" />
                                  <path d="M17 12h4" />
                                  <path d="M18.364 5.636l-2.828 2.828" />
                                  <path d="M8.464 15.536l-2.828 2.828" />
                                  <path d="M5.636 5.636l2.828 2.828" />
                                  <path d="M15.536 15.536l2.828 2.828" />
                                </svg>
                              </span>
                              <span class="font-medium text_white">{{item.totalBet}}</span>
                            </dd>
                          </div>
                        </td>
                        <!-- Datos de "Ganancia" -->
                        <td class="p-4 text-md font-normal text_white whitespace-nowrap">
                          <div class="flex items-center space-x-2">
                            <dd class="text-sm font-semibold text_gray flex items-center gap-2">
                              <span class="text_yellow text-xl gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                  fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                  stroke-linejoin="round"
                                  class="icon icon-tabler icons-tabler-outline icon-tabler-poker-chip">
                                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                  <path d="M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
                                  <path d="M12 3v4" />
                                  <path d="M12 17v4" />
                                  <path d="M3 12h4" />
                                  <path d="M17 12h4" />
                                  <path d="M18.364 5.636l-2.828 2.828" />
                                  <path d="M8.464 15.536l-2.828 2.828" />
                                  <path d="M5.636 5.636l2.828 2.828" />
                                  <path d="M15.536 15.536l2.828 2.828" />
                                </svg>
                              </span>
                              <span class="font-medium text_white">{{item.totalWin}}</span>
                            </dd>
                          </div>
                        </td>

                        <!-- Datos de "Hora" -->
                        <td class="p-4 text-sm font-normal text_white whitespace-nowrap">
                          {{ item.createdAt | date: 'dd MMM yyyy / HH:mm':'UTC' }}
                      </tr>
                    </ng-template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- Card Footer -->
      </div>
    </div>
    <!-- Paginador Últimas Transacciones -->
    <div
      class="flex items-center justify-center border-t border-t-2 border_customize_card card_color px-4 py-3 sm:px-6 rounded-b-lg shadow-md">
      <div class="hidden lg:flex lg:flex-1 lg:items-center lg:justify-between lg:flex-nowrap">
        <div>
          <p class="text-sm text_white flex items-center whitespace-nowrap">
            Mostrando las ultimas {{showing}} entradas
            <span class="font-medium mx-1">{{from}}</span>
            al
            <span class="font-medium mx-1">{{to}}</span>
            de
            <span class="font-medium mx-1">{{total}}</span>
          </p>
        </div>
      </div>


      <div
        class="flex items-center justify-between border_customize_card card_color px-4 py-3 sm:px-6 rounded-b-lg shadow-md">
        <!-- ... (tu código existente) ... -->
        <div class="w-full flex justify-center lg:justify-end">
          <nav class="isolate inline-flex -space-x-px" aria-label="Pagination">
            <!-- Flecha "Anterior" -->
            <a (click)="previousPage()"
              class="rounded-l-md relative inline-flex items-center text_color_customize hover:text_black px-2 py-2 line_customize line_inset_customize hover:button_color_customize">
              <span class="sr-only">Previo</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="text-xl icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-left">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M12 21a9 9 0 1 0 0 -18a9 9 0 0 0 0 18" />
                <path d="M8 12l4 4" />
                <path d="M8 12h8" />
                <path d="M12 8l-4 4" />
              </svg>
            </a>
            <button *ngFor="let page of pages"
              [ngClass]="page === pagination.currentPage ? 
              'page-link relative z-10 inline-flex items-center px-4 py-2 text-sm font-semibold line_customize line_inset_customize hover:button_color_customize template_color_customize'
              :
              'page-link relative z-10 inline-flex items-center text_white hover:text_black px-4 py-2 text-sm font-semibold line_customize line_inset_customize hover:button_color_customize'"
              (click)="goToPage(page)" [disabled]="page === '...'">
              {{ page }}
            </button>

            <!-- Flecha "Siguiente" -->
            <a (click)="nextPage()"
              class="relative inline-flex items-center text_color_customize hover:text_black px-2 py-2 line_customize line_inset_customize hover:button_color_customize rounded-r-md">
              <span class="sr-only">Próximo</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="text-xl icon icon-tabler icons-tabler-outline icon-tabler-circle-arrow-right">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18" />
                <path d="M16 12l-4 -4" />
                <path d="M16 12h-8" />
                <path d="M12 16l4 -4" />
              </svg>
            </a>
          </nav>
        </div>
      </div>
    </div>
  </div>
</section>